export default {
  ticketsArray: [],
  copiasArray: [
    { text: 1 }, { text: 2 }, { text: 3 }, { text: 4 }, { text: 5 }
  ],
  //esta variable será fija y se definirá en base a los tickets raw que diseñemos
  tiposTickets: [
    {
      value: 'caja1',
      text: 'Caja tipo 1'
    },
    {
      value: 'caja2',
      text: 'Caja tipo 2'
    },
    {
      value: 'cocina1',
      text: 'Cocina 1'
    },
    {
      value: 'cocina2',
      text: 'Cocina 2'
    },
  ],
  sizeItems: [
    {
      value: 'small',
      text: 'Pequeño'
    },
    {
      value: 'big',
      text: 'Grande'
    }],
  cabeceraTicketsItems: [
    {
      text: 'Fondo negro grande',
      value: 'fondoNegro'
    },
    {
      text: 'Pequeño sin fondo',
      value: 'sinFondo'
    }
  ]
}